export default __webpack_public_path__ + "static/media/sudden_attack_banner_highlight.23004f4e.png";